module.exports = __webpack_public_path__ + "f8bea97c1be3db7da4e587684d4d1583.svg";